module.exports = __webpack_public_path__ + "static/media/nina_yeh.74bdd32d.jpg";